import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {NameProps} from '@components/timeline-new/tasks/columns/types'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {ColumnId} from '@components/timeline-new/types'
import {EditableTitle} from '@components/upper-panel/editable-title'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {TwCell} from './containers'
import {EntityTitle} from './entity-title'

const TwEntityTitle = tw(EntityTitle)`
  text-sm-semibold
  text-primary
  truncate
  flex-1
`

const TwEditableTitle = tw(EditableTitle)`
  text-sm-semibold
  text-primary
  placeholder:text-placeholder-new
  h-16
  min-h-16
  max-h-16
  flex-1
`

export const BoardTitle = observer<NameProps>(props => {
  const {hub, path} = props

  const [, store] = useTimelineNewStore()
  const editing = store.isCellEditing(path, ColumnId.title)

  useSyncEventUpdateEffect('current', {filter: hub?.id, deps: [hub?.id]})

  if (!hub) {
    return null
  }

  return (
    <TwCell className="truncate">
      {editing ? (
        <TwEditableTitle
          title={hub.title}
          placeholder={Lang.msg.timeline.boardTitlePlaceholder}
          onSubmit={title => store.editEntityTitle(title, hub.id)}
        />
      ) : (
        <TwEntityTitle hubId={hub.id} path={path} title={hub.title} />
      )}
    </TwCell>
  )
})
